import React, { useEffect, useRef } from "react";
import { scrollTo } from "@/utils/scroller";
import { useHistory } from "react-router-dom";

let isFirstRender = true;
const Scroller = () => {
  const history = useHistory();
  const ref = useRef();
  useEffect(() => {
    const handler = () => {
      setTimeout(() => {
        scrollTo(ref.current);
      }, 100);
    };
    if (history.action === "POP") {
      if (isFirstRender) {
        handler();
      }
    } else if (history.action === "PUSH") {
      handler();
    }
    if (isFirstRender) {
      isFirstRender = false;
    }
    return history.listen((loc) => {
      if (loc.pathname.includes("/search")) {
        if (history.action === "PUSH") {
          handler();
        }
      }
    });
  }, []);
  return (
    <div
      id="search-scroll-line"
      ref={ref}
      css={`
        width: 100%;
        height: 35px;
      `}
    ></div>
  );
};

export default Scroller;
